import { useState, useEffect } from 'react';
import { isEmpty } from '../../../utils/isEmpty';
import { getDataFromLocalStorage, setDataInLocalStorage } from '../utils/LocalStorage';
import { getPopularTrainsFromAPI } from '../utils/ApiHandlers';
import { TrainDetail } from '../types/LTSTypes';
import { POPULAR_TRAIN_KEY } from '../constants/LTSConstants';

const usePopularTrains = () => {
  const [popularTrains, setPopularTrains] = useState([] as TrainDetail[]);

  const getPopularTrains = async () => {
    const popularTrainsFromLS: TrainDetail[] | undefined | null = await getDataFromLocalStorage(POPULAR_TRAIN_KEY);

    if (!isEmpty(popularTrainsFromLS) && popularTrainsFromLS?.length && popularTrainsFromLS.length > 0) {
      setPopularTrains(popularTrainsFromLS);
    }

    const popularTrainsFromAPI: TrainDetail[] | undefined | null = await getPopularTrainsFromAPI();
    if (!isEmpty(popularTrainsFromAPI) && popularTrainsFromAPI?.length && popularTrainsFromAPI.length > 0) {
      setPopularTrains(popularTrainsFromAPI);
      setDataInLocalStorage(POPULAR_TRAIN_KEY, popularTrainsFromAPI);
    }
  };

  useEffect(() => {
    getPopularTrains();
  }, []);

  return popularTrains;
};

export default usePopularTrains;
